import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SC1 = styled.div<{
	isModal: boolean;
	paddingTop: string | number;
	paddingBottom: string | number;
}>({
	position: 'relative',
	width: '100%',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	borderTop: (props) =>
		props.isModal
			? `${props.paddingTop}px solid ${token('elevation.surface.overlay')}`
			: `${props.paddingTop}px solid ${token('elevation.surface')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	borderBottom: (props) =>
		props.isModal
			? `${props.paddingBottom}px solid ${token('elevation.surface.overlay')}`
			: `${props.paddingBottom}px solid ${token('elevation.surface')}`,
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export default SC1;
